import React from "react";
import * as Lucide from "lucide-react";
import {
  ClipboardCheck, Factory, Wrench, Headphones, CalendarCheck, Wifi,
} from "lucide-react";
import { useI18n } from "../context/I18nContext";

const FALLBACK_ICONS = [ClipboardCheck, Factory, Wrench, Headphones, CalendarCheck, Wifi];

function resolveIcon(name, fallback) {
  if (name && typeof Lucide[name] === "function") return Lucide[name];
  return fallback;
}

export function Services({ items = [] }) {
  const { t } = useI18n();

  const services =
    items && items.length > 0
      ? items.map((s) => ({ title: s.title, desc: s.desc, icon: s.icon }))
      : t.services.items.map((it, i) => ({
          title: it.title,
          desc: it.desc,
          icon: null,
        }));

  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-20 lg:py-32 bg-white relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid-dark opacity-40 pointer-events-none" />
      <div className="relative max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-14">
          <div className="lg:col-span-8">
            <div data-reveal className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#0d1b2a]/60">
              {t.services.eyebrow}
            </div>
            <h2
              data-reveal
              className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#0d1b2a]"
              style={{ fontFamily: "Chivo, Inter, sans-serif" }}
              data-testid="services-heading"
            >
              {t.services.heading}
            </h2>
          </div>
          <p data-reveal className="lg:col-span-4 text-base text-[#0d1b2a]/70 leading-relaxed">
            {t.services.sub}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((item, i) => {
            const Icon = resolveIcon(item.icon, FALLBACK_ICONS[i % FALLBACK_ICONS.length]);
            return (
              <div
                key={i}
                data-reveal
                data-testid={`service-item-${i}`}
                className="group relative bg-white border border-[#0d1b2a]/10 rounded-xl p-7 hover:border-[#ffb703] transition-all duration-300 hover:-translate-y-1"
                style={{ transitionDelay: `${i * 50}ms` }}
              >
                <div className="absolute top-0 right-0 px-3 py-1 text-[10px] font-bold text-[#0d1b2a]/40 tracking-[0.2em]">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="w-12 h-12 rounded-lg bg-[#0d1b2a] text-[#ffb703] flex items-center justify-center group-hover:bg-[#ffb703] group-hover:text-[#0d1b2a] transition-colors">
                  <Icon size={22} />
                </div>
                <h3
                  className="mt-5 text-lg font-bold text-[#0d1b2a]"
                  style={{ fontFamily: "Chivo, Inter, sans-serif" }}
                >
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-[#0d1b2a]/70 leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
